<template lang="pug">
.form-residential-about
    span.form-residential-about__header
        | Анонс

    .form-residential-about__text
        ckeditor(
            v-model="preview_text"
            :editor="editor"
            :config="editorConfig"
        )

    span.form-residential-about__header
        | Полное описание

    .form-residential-about__text
        ckeditor.ckeditor.ck-editor.ck-content(
            v-model="detail_text"
            :editor="editor"
            :config="editorConfig"
        )
</template>

<script>
import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'FormResidentialAbout',

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        ckfinder: {
          // Upload the images to the server using the CKFinder QuickUpload command.
          uploadUrl: '/admin/residentials/' + this.$route.params.id + '/upload-inline-image',

          // Define the CKFinder configuration (if necessary).
          options: {
            resourceType: 'Images',
            pass: 5,
          },
        },
        toolbar: {
          viewportTopOffset: 0,
        },
        language: 'ru',
      },
    };
  },

  mounted() {
  },

  computed: {
    ...mapGetters({
        current: 'residential/getCurrent',
    }),

    detail_text: {
      get() { return this.current.detail_text; },
      set(detail_text) { this.setValue({ detail_text }); },
    },

    preview_text: {
      get() { return this.current.preview_text; },
      set(preview_text) { this.setValue({ preview_text }); },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
    }),
  }
};
</script>

<style lang="scss">
.form-residential-about {
    display: grid;
    grid-template-columns: 265px 1fr;
    margin-top: 50px;
    grid-column-gap: 50px;
    grid-row-gap: 50px;
    justify-items: end;
    align-items: start;
    padding-right: 100px;
    padding-bottom: 50px;

    &__text {
        width: 100%;
    }
}

.ckeditor {
  height: 100%;
}
</style>
